import * as React from "react";

/**
 * UpdateAvailableToast — wenn der SW eine neue version registriert
 * (vite-plugin-pwa registerType: 'prompt' → onNeedRefresh-event),
 * zeigen wir einen subtilen bottom-toast mit "App aktualisieren"-button.
 *
 * Kein silent skipWaiting — verhindert mid-form-fill-disruption.
 */

export function UpdateAvailableToast(): React.ReactElement | null {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const handler = () => setVisible(true);
    window.addEventListener("hitzeprotokoll:sw-update", handler);
    return () => window.removeEventListener("hitzeprotokoll:sw-update", handler);
  }, []);

  const apply = React.useCallback(async () => {
    if (typeof window.__hpUpdateSW === "function") {
      await window.__hpUpdateSW(true); // true → reloadPage nach SW-swap
    } else {
      window.location.reload();
    }
  }, []);

  if (!visible) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-4 left-1/2 z-[var(--z-toast)] flex w-[calc(100%-2rem)] max-w-md -translate-x-1/2 items-center justify-between gap-3 rounded-lg bg-[color:var(--color-neutral-900)] px-4 py-3 text-sm text-white shadow-[var(--shadow-lg)]"
    >
      <span>Eine neue Version steht bereit.</span>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => setVisible(false)}
          className="rounded-md px-2 py-1 text-xs text-neutral-300 hover:bg-neutral-800"
        >
          Später
        </button>
        <button
          type="button"
          onClick={apply}
          className="rounded-md bg-[color:var(--color-brand-primary-strong)] px-3 py-1.5 text-xs font-semibold text-white"
        >
          Aktualisieren
        </button>
      </div>
    </div>
  );
}
